import React, { useContext, useEffect, useState } from "react";
import ModalPopup from "../../../components/ui/Modals/ModalMessages/ModalPopup";
import DiallerKeyPad from "../Dialler/DiallerKeyPad";
import KeypadCallModal from "../../../components/ui/Modals/ModalMessages/KeypadCallModal";
import { RechargeContext } from "../../../RechargeContext";

const PhoneCallButtonFunctional = (props) => {
	 const { openRecharge } = useContext(RechargeContext);
	const [openDialPad, setOpenDialPad] = useState(false);
	const [phoneNumber, setPhoneNumber] = useState(null);

	useEffect(() => {
		let { to } = props;
		if (to) {
			setPhoneNumber(to);
		}
	}, [props]);

	// fix time between calling the user

	const openDialpadFnc = () => {
		setOpenDialPad(true);
	};

	const closeDiallerPad = () => {
		setOpenDialPad(false);
	};

	const { className = "", style = {} } = props;
	return (
		<>
			<a onClick={openDialpadFnc} className={className} style={style}>
				{props.children}
			</a>
			{openDialPad && (
				<KeypadCallModal size="sm" noHeader className="dialler-modal p-0 overflow-hidden">
					<DiallerKeyPad
						callerInfo={{ toNumber: phoneNumber }}
						onClose={closeDiallerPad}
						noBalance={() => (typeof openRecharge === 'function' ? openRecharge() : {})}

					/>
				</KeypadCallModal>
			)}
		</>
	);
};

//commenting pulling of redux state as it is not needed for now,
// if needed then just uncomment the code below

// const mapDataToProps = (state) => {
// 	return {
// 		user: state.user,
// 		balance: state.user.balance,
// 		isPostpaidUser: state.user.voipStatus || false,
// 	};
// };

// export default connect(mapDataToProps, null)(PhoneCallButtonFunctional);
export default PhoneCallButtonFunctional;
